import { ADD_BASKET, GET_BASKET, REMOVE_BASKET } from '../../util/actionTypes';
const initialState = {data:[]};

const basketReducer = (state =initialState, action) => {
    switch (action.type) {
   
        case ADD_BASKET: 
            return {
                ...state,
                data :action.payload, 
            };     
        case REMOVE_BASKET:
            return {};
        default:
            return state;
    }
};

export default basketReducer;
